export default __webpack_public_path__ + "static/media/hamburger.b8b001ec.svg";